<ngx-loading-bar [color]="loaderColor" [includeSpinner]="false"></ngx-loading-bar>
<p-toast />
<p-confirmDialog />
<router-outlet></router-outlet>